export const checkIbanForValidity = {
	getMessage(field) {
		return field + " muss eine gültige IBAN sein.";
	},
	validate(value) {
		if(value) {
			return new RegExp("^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}").test(value);
		} else {
			return true;
		}
	},
};


// WEBPACK FOOTER //
// ./src/validator/checkIbanForValidity.js